import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
} from '@angular/core';
import { ILogoConfig } from '@nibtravel/shared/ui/components/logo';

import { IFooterConfig } from './models/footer.interfaces';

@Component({
  selector: 'nibtravel-footer',
  templateUrl: './footer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent {
  @HostBinding('class') classes = 'footer';
  @Input() footerConfig!: IFooterConfig;
  @Input() logoConfig!: ILogoConfig;
}
